import React from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import useSiteConfig from "@/hooks/useSiteConfig";
import { parseLocaleFromPath, localePath } from "@/lib/locale";

/**
 * Gate for e-commerce routes (cart, checkout, configurator).
 * When `commerce_mode_enabled` is false in site-config, redirects to /models
 * (localised) so the visitor lands on the inquiry-first catalogue.
 *
 * Set `allowIfSessionId` on the /checkout/success route so an in-flight
 * Stripe redirect still resolves even while commerce is being turned off.
 */
export default function CommerceGate({ children, allowIfSessionId = false }) {
  const cfg = useSiteConfig();
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  const { locale } = parseLocaleFromPath(pathname);

  // While config loads, avoid flashing the redirect for a single frame.
  // useSiteConfig starts with cached value (or {}); when empty, allow render.
  if (Object.keys(cfg).length === 0) {
    return children;
  }
  const enabled = !!cfg.commerce_mode_enabled;
  if (enabled) return children;

  if (allowIfSessionId && params.get("session_id")) {
    return children;
  }
  return <Navigate to={localePath(locale, "/models")} replace />;
}
